
export default "/assets/arrow-up-right-micro.6ca975f9.svg"